import React from 'react'
import PropTypes from 'prop-types'
// import noop from 'lodash/noop'
import { Circles } from 'react-loader-spinner'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { isParksfo, formatDecimal, formatDaysHoursMinutes, isAirPort } from '../../utils/helper'



const PriceBreackup = (props) => {
  // const {BookingEdit,priceDetails,timeupdate,loaderPrice,promoCodeApply,discount}=props
  const { priceDetails, loaderPrice, promoCodeApply, discount, promoRes, selectedFacilityData, isVehicleOversize, selectedPaymentType, totalHoursLengthRef, applyPromoLoder, selectedAmenities } = props
 
  return (
    <div className='mt-2'>
      {loaderPrice || applyPromoLoder ? (
        <span
          className="mx-auto my-5 d-block"
          style={{ width: '30px' }}
        >
          <Circles
            height="20"
            width="20"
            style={{ display: 'inline-block' }}
            color="#000"
            ariaLabel="circles-loading"
            visible={true}
          />
        </span>
      ) : priceDetails?.parking_amount != 'N/A' && !isNaN(Number(priceDetails?.parking_amount)) ? (
        <div className="px-3">
          <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Total Parking Duration</p>{' '}
            <p className="m-0 text-end">
              <b>
                {formatDaysHoursMinutes(totalHoursLengthRef?.current)}
              </b>
            </p>
          </div>
          {selectedFacilityData?.facility_configuration?.is_process_fee_charged != '1' ? <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Parking Amount</p>{' '}
            <p className="m-0">
              <b>
                $
                {priceDetails?.parking_amount
                  ? isNaN(Number(priceDetails?.parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.parking_amount)
                  : formatDecimal(0)}
              </b>
            </p>
          </div> : null}

          {/* EOS-5093 Amenities, shown only while the user has some selected */}
          {selectedAmenities?.length > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0 text-danger">(*Amenities fee applied)</p>{' '}
              {/* <p className="m-0 text-danger">
                <b>
                  $
                  {priceDetails?.amenity_fee
                    ? isNaN(Number(priceDetails?.amenity_fee)) ? 'N/A' : formatDecimal(priceDetails?.amenity_fee)
                    : formatDecimal(0)}
                </b>
              </p> */}
            </div>
          )}

          {priceDetails?.net_parking_amount > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0">Net Parking Amount</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.net_parking_amount
                    ? isNaN(Number(priceDetails?.net_parking_amount)) ? 'N/A' : formatDecimal(priceDetails?.net_parking_amount)
                    : formatDecimal(0)}
                </b>
              </p>
            </div>
          )}

          {priceDetails?.tax_fee > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> {`${isParksfo() ? 'City Parking Tax' : 'Tax'}`}</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.tax_fee
                    ? isNaN(Number(priceDetails?.tax_fee)) ? 'N/A' : formatDecimal(priceDetails?.tax_fee)
                    : formatDecimal(0)}
                </b>
              </p>
            </div>
          )}
          {priceDetails?.surcharge_fee > 0 && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> {`${isParksfo() ? 'Fuel Surcharge Fee' : 'Surcharge Fee'}`}</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.surcharge_fee
                    ? formatDecimal(priceDetails?.surcharge_fee)
                    : formatDecimal(0)}
                </b>
              </p>
            </div>
          )}
          {priceDetails?.additional_fee > 0 && isParksfo() ? (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> Airport Access Fee</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.additional_fee
                    ? formatDecimal(priceDetails?.additional_fee)
                    : formatDecimal(0)}
                </b>
              </p>
            </div>
          ) : null}
          {priceDetails?.processing_fee > 0 && isParksfo() ? (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> {isAirPort() ? 'Airport Access Fee':'Processing Fee'}</p>{' '}
              <p className="m-0">
                <b>
                  $
                  {priceDetails?.processing_fee
                    ? formatDecimal(priceDetails?.processing_fee)
                    : formatDecimal(0)}
                </b>
              </p>
            </div>
          ) : null}
          {((priceDetails?.processing_fee && priceDetails?.processing_fee > 0) || (priceDetails?.additional_fee && priceDetails?.additional_fee > 0)) && !isParksfo() ? (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0"> {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Reservation Fee' : isAirPort() ? 'Airport Access Fee' : 'Processing Fee'}  </p>{' '}
              <p className="m-0">
                <b>

                  ${isParksfo() ? formatDecimal(priceDetails?.processing_fee || '0') : formatDecimal(Number(priceDetails?.processing_fee || '0') + Number(priceDetails?.additional_fee || '0'))}
                  {/* {priceDetails?.processing_fee
                    ? isNaN(Number(priceDetails?.processing_fee)) ? 'N/A' : parseFloat(priceDetails?.processing_fee).toFixed(2)
                    : '0.00'} */}
                </b>
              </p>
            </div>
          ) : null}
          {promoCodeApply && (
            <div className="d-flex justify-content-between mb-1 ">
              <p className="m-0">
                <p className='m-0'>{promoRes?.promocode?.discount_type == 'hours' ? `Validated Amount (${promoRes?.discount_in_hours} Hrs Free)` : selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 ? 'Coupon Discount' : 'Discount'} </p>{' '}
                {selectedFacilityData?.facility_configuration?.enable_third_party_coupons == 1 ? <p className='small'>{priceDetails?.applied_promo_code?.name || priceDetails?.promocode_name || promoRes?.promocode?.promocode_name ? `(${priceDetails?.applied_promo_code?.name || priceDetails?.promocode_name || promoRes?.promocode?.promocode_name})` : null}</p> : null}
              </p>
              <p className="m-0">
                <b>- ${formatDecimal(discount)}</b>
              </p>
            </div>
          )}

          {isVehicleOversize && <div className="row">
            <small className="text-danger small col-8 d-block">
              <span className="text-danger small d-block p-0 m-0">(**Oversize Fee Applied)</span>
            </small>
          </div>}



          <div className="d-flex border-top justify-content-between mb-1 pt-2 ">
            <h4 className="font-weight-bold h5 text-primary m-0 ">
              {(selectedPaymentType == 0 && isParksfo()) ? 'Estimated Total' : selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ? 'Total Due' : 'Amount Due'}
            </h4>
            {selectedFacilityData?.facility_configuration?.is_process_fee_charged == '1' ?
              <h4 className="font-weight-bold h5 text-primary ">
                $
                {priceDetails?.processing_fee
                  ? isNaN(Number(priceDetails?.processing_fee)) ? 'N/A' : formatDecimal(priceDetails?.processing_fee)
                  : formatDecimal(0)}{' '}
              </h4>
              :
              <h4 className="font-weight-bold h5 text-primary ">
                $
                {priceDetails?.payable_amount
                  ? isNaN(Number(priceDetails?.payable_amount)) ? 'N/A' : formatDecimal(priceDetails?.payable_amount)
                  : formatDecimal(0)}{' '}
              </h4>
            }
          </div>
        </div>
      ) : (
        <div className="px-3">
          <div className="d-flex justify-content-between mb-1 ">
            <p className="m-0">Parking Amount</p>{' '}
            <p className="m-0">
              <b>{!isNaN(Number(priceDetails?.parking_amount)) ? formatDecimal(priceDetails?.parking_amount) : 'N/A'}</b>
            </p>
          </div>
        </div>
      )
      }
    </div>
  )
}

PriceBreackup.propTypes = {
  loaderPrice: PropTypes.bool,
  priceDetails: PropTypes.object,
  discount: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  promoCodeApply: PropTypes.bool,
  timeupdate: PropTypes.bool,
  BookingEdit: PropTypes.bool,
  promoRes: PropTypes.object,
  selectedFacilityData: PropTypes.object,
  isVehicleOversize: PropTypes.bool,
  selectedPaymentType: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  totalHoursLengthRef: PropTypes.arrayOf([PropTypes.string, PropTypes.number]),
  applyPromoLoder: PropTypes.bool,
  selectedAmenities: PropTypes.array,
}

PriceBreackup.defaulProps = {
  loaderPrice: false,
  priceDetails: EMPTY_OBJECT,
  discount: '',
  promoCodeApply: false,
  timeupdate: false,
  BookingEdit: false,
  promoRes: EMPTY_OBJECT,
  selectedFacilityData: EMPTY_OBJECT,
  isVehicleOversize: false,
  selectedPaymentType: null,
  totalHoursLengthRef: null,
  applyPromoLoder: false,
  selectedAmenities: EMPTY_ARRAY,
}

export default PriceBreackup
